import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';

@Component({
  selector: 'app-rcti-invoice-repairlab',
  templateUrl: './rcti-repairlab.component.html',
  styleUrls: ['./rcti-repairlab.component.scss', '../../pages/invoice-table.scss']
})
export class RCTIRepairLabComponent extends InvoiceComponent implements OnInit {
  @Input()
  invoice: InvoiceInterface;

  displayedColumns: string[] = [
    'item',
    'qty',
    'unit',
    'price',
    'actions'
  ];

  defaultInvoice = {
    type: 'rcti-repairlab',
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: '',
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: 'repairlab-rcti'
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0,
        unit: 'kg'
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  };
}
